<scitis-app-global-page-header [pageTitle]="'Gateway administration'">

  <ng-template #entryCount>
    <div class="page-header-counts">
      <div class="count">
        <span class="badge badge-pill badge-primary" [innerText]="gatewaysCount"></span>
        <span class="count-label" translate>Gateways</span>
      </div>
    </div>
  </ng-template>

  <ng-template #filterElement>
    <div class="search">
      <input [(ngModel)]="searchTerm" (change)="onSearchGateways($event)" [placeholder]="('Search gateway' | translate)+'...'"
             class="form-control"
             type="search">
    </div>
  </ng-template>


  <ng-template #filterElement>
    <div #dropdownFilter="ngbDropdown" [autoClose]="'outside'" class="d-inline-block" ngbDropdown
         placement="bottom-right">
      <button class="btn btn-outline-primary" id="dropdownFilter" ngbDropdownToggle>
        <span [class.d-none]="appliedNumberOfFilters!==0" class="fa-solid fa-filter"></span>
        <span [class.d-none]="appliedNumberOfFilters===0" [innerText]="appliedNumberOfFilters"
              class="badge badge-pill badge-primary badge-round mr-1"></span>
        <span translate>Filter</span>
      </button>
      <div aria-labelledby="dropdownFilter" ngbDropdownMenu>
        <div class="form-group mb-1">
          <label for="selectOrganization" translate>Organization</label>
          <ng-select (change)="onChangeOrganization($event)"
                     (mousedown)="$event.stopPropagation()"
                     [(ngModel)]="selectedOrganizationId"
                     [clearable]="isSuperAdminRole"
                     [disabled]="isLoading"
                     [items]="organizations"
                     [placeholder]="'Select organization'|translate"
                     bindLabel="name" bindValue="id"
                     id="selectOrganization"
                     style="width: 220px;">
            <ng-template ng-option-tmp let-item="item">
              <div [title]="item.name" [innerHTML]="item.name" class="dropdown-tooltip-hover-administration"></div>
            </ng-template>
          </ng-select>
        </div>

        <div class="form-group">
          <label for="selectMachineryGroups" translate>Machinery group</label>
          <ng-select (change)="onChangeMachineryGroup($event)"
                     (mousedown)="$event.stopPropagation()"
                     [(ngModel)]="selectedMachineryGroupId"
                     [clearable]="isSuperAdminRole"
                     [disabled]="isLoading"
                     [items]="machineryGroupsList"
                     [placeholder]="'Select machinery group'|translate"
                     bindLabel="name"
                     bindValue="id"
                     id="selectMachineryGroups"
                     style="width: 220px;">
            <ng-template ng-option-tmp let-item="item">
              <div [title]="item.name" [innerHTML]="item.name" class="dropdown-tooltip-hover-administration"></div>
            </ng-template>
          </ng-select>

        </div>
        <button (click)="onApplyFilterClick(); dropdownFilter.close();"
                [disabled]="isLoading"
                class="btn btn-primary btn-block"
                translate>Apply filters
        </button>

      </div>
    </div>
  </ng-template>

  <ng-template #filterElement>
    <div class="d-inline-block" ngbDropdown>
      <button class="btn btn-outline-primary" id="dropdownActions" ngbDropdownToggle>
        <span translate>Actions</span>
      </button>
      <div aria-labelledby="dropdownActions" ngbDropdownMenu>
        <button (click)="onAddGateway()" [disabled]="!isTechAdminRole && !isSuperAdminRole || isLoading"
                ngbDropdownItem>
          <span class="fa-solid fa-plus"></span>
          <span translate>New Gateway</span>
        </button>
        <button (click)="onUpdateGateway()" [disabled]="!onDisplayUpdateAllGatewaysButton()" ngbDropdownItem>
          <span class="fa-solid fa-arrows-rotate"></span>
          <span translate>Update Gateways</span>
        </button>
      </div>
    </div>
  </ng-template>

</scitis-app-global-page-header>


<div class="card card-table-view mb-3">
  <div class="card-body">
    <div class="table-responsive-md">
      <table class="table vertical-align-middle mb-0">
        <thead>
        <tr>
          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="name" style="width:25%">
            <span translate>Name</span>
          </th>
          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="cloudplugType" style="width:25%">
            <span translate>Type</span>
          </th>
          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="machineName" style="width:25%">
            <span translate>Machine</span>
          </th>
          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="tenantName" style="width:25%">
            <span translate>Organization</span>
          </th>
          <th style="width:150px">
            <span translate>Config</span>
          </th>
          <th style="width:10%">
            <span translate>Update status</span>
          </th>
          <th class="text-right" scope="col">
            <span translate>Action</span>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let gateway of gatewayList | paginate: paginateSettings">
          <td>
            <div class="form-row">
              <div class="col-auto">
                <span [ngClass]="gatewayStatusClasses[gateway.status]||''" class="status mr-0">
                </span>
              </div>
              <div class="col">
                <strong class="truncate d-inline-flex" style="max-width: 280px;">
                  <ngb-highlight [result]="gateway.name" [term]="searchTerm" [title]="gateway.name"></ngb-highlight>
                </strong>
                <ng-template #ToolTipTemplate>
                  <span translate>Authenticated connection</span>
                </ng-template>
                <em [ngClass]="{
                  'fa-solid fa-lock': (gateway.usingSharedSecretKey),
                  'fa-solid fa-lock-open':  (!gateway.usingSharedSecretKey)
                }"
                    [ngbTooltip]="(gateway.usingSharedSecretKey) ? ToolTipTemplate : ''"
                    class="ml-2 text-muted" placement="top"
                ></em>
                <br>
                <small class="text-muted truncate" style="max-width: 280px;">
                  <span translate>S/N</span>:
                  <ngb-highlight [result]="gateway.id" [term]="searchTerm" [title]="gateway.id"></ngb-highlight>
                </small>
              </div>
            </div>
          </td>
          <td>
            <ngb-highlight [result]="gateway.cloudplugType|translate" [term]="searchTerm"></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="gateway.machineName" [term]="searchTerm" [title]="gateway.machineName"
                           class="truncate"
                           style="max-width: 280px;"></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="gateway.tenantName" [term]="searchTerm"></ngb-highlight>
          </td>
          <td>
            <ng-template #ToolTipConfig>
              <span translate>Last upload</span>: <span
              [innerText]="gateway.configuration.lastUpload | date:'medium'"></span>
            </ng-template>
            <span [innerText]="gateway.configuration.status"
                  [ngClass]="gateway.configuration.cssClass"
                  [ngbTooltip]="(gateway.configuration.lastUpload) ? ToolTipConfig : ''" class="badge badge-pill">
            </span>
          </td>
          <td>
            <!-- NONE, AVAILABLE, PENDING, PROGRESS, SUCCESS, ERROR -->
            <span [ngClass]="updatedStateClassOptions[gateway.updateStatus?.state||'']||''" class="badge badge-pill">
              <span
                *ngIf="gateway.updateStatus?.state ===  updateState.NONE || gateway.updateStatus?.state ===  updateState.ERROR"
                translate>Unknown</span>

              <span *ngIf="(gateway.updateStatus?.state ===  updateState.AVAILABLE ||
                                                        gateway.updateStatus?.state ===  updateState.PENDING ||
                                                        gateway.updateStatus?.state ===  updateState.PROGRESS)"
                    translate>Update available</span>

              <span *ngIf="gateway.updateStatus?.state ===  updateState.SUCCESS" translate>Actual</span>
            </span>
          </td>
          <td class="text-right">
            <scitis-admin-gateway-action (gatewayDeleteEvent)="onDeleteGatewaySuccess(gateway)"
                                         (gatewayUpdatedEvent)="onGatewayUpdated(gateway)"
                                         [gateway]="gateway"
                                         [searchTerm]="searchTerm"
                                         [isAdminRole]="isAdminRole"
                                         [isSuperAdminRole]="isSuperAdminRole"
                                         [isTechAdminRole]="isTechAdminRole"
                                         [isDistributorRole]="isDistributorRole">
            </scitis-admin-gateway-action>
          </td>
        </tr>
        </tbody>
      </table>
      <div *ngIf="gatewayList.length === 0"
           class="d-flex align-items-center justify-content-center mb-0 mt-3 alert alert-info text-center">
        <em class="fa-solid fa-circle-info mr-2"></em>
        <span translate>No gateways found for searched term and filters.</span>
      </div>
    </div>
  </div>
</div>

<scitis-ngx-pagination [id]="paginateSettings.id"
                       paginationClass="col"
                       [itemsPerPage]="paginateSettings.itemsPerPage"
                       [itemsPerPageOptions]="itemsPerPageOptions"
                       (pageNumberChange)="onLoadPageNumber($event)"
                       (itemsPerPageChange)="onItemsPerPageChange($event)">
</scitis-ngx-pagination>
